import { Card } from "@/components/ui/card";
import { TaskProgress } from "@/components/tasks/TaskSummaryCard";
import { UserIcon } from "@/lib/icons";
import type { MemoList } from "@/lib/memoList";

/** Board card for one user's Muistilista, styled like `TaskSummaryCard`. */
export function MemoListCard({
  list,
  isOwn,
  onClick,
}: {
  list: MemoList;
  isOwn: boolean;
  onClick: () => void;
}) {
  const countLabel = list.totalCount === 1 ? "1 tehtävä" : `${list.totalCount} tehtävää`;

  return (
    <Card
      className="relative p-4 cursor-pointer hover:bg-accent/50 transition-colors border-l-4 border-l-slate-300"
      onClick={onClick}
    >
      <div className="space-y-3 pl-2">
        <div className="flex flex-wrap items-center gap-1.5 pr-10 -ml-2">
          <h3 className="inline-block rounded bg-muted px-2 py-0.5 text-base font-medium leading-snug text-foreground">
            Muistilista
          </h3>
          <span className="inline-flex min-w-0 items-center gap-1 rounded bg-muted px-2 py-0.5 text-sm font-medium leading-snug text-foreground">
            <UserIcon className="h-3 w-3 shrink-0" />
            <span className="truncate">{list.ownerName}</span>
          </span>
        </div>

        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-muted-foreground">
          <span>{countLabel}</span>
          {list.overdueCount > 0 && (
            <span className="font-medium text-red-600">{list.overdueCount} myöhässä</span>
          )}
        </div>

        <TaskProgress
          showWhenEmpty
          progress={{
            pending: list.totalCount - list.completedCount - list.inProgressCount,
            inProgress: list.inProgressCount,
            completed: list.completedCount,
            problem: 0,
            total: list.totalCount,
          }}
        />
      </div>
    </Card>
  );
}
